import React from 'react';
import { banks } from '@utils';
import { TextInput, ComboBox, Button } from '@components';
import { Formik, Field } from 'formik';
import {
  DadosBancariosRequerimentosInitialValues,
  DadosBancariosRequerimentosSchema,
} from '@schemas';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { enviaFormRequest } from '../../../../store/modules/user/actions';

export const DadosBancarios = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          enableReinitialize
          initialValues={DadosBancariosRequerimentosInitialValues}
          validationSchema={DadosBancariosRequerimentosSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isSubmitting, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12 col-md-6">
                  <Field
                    name="banco"
                    className="mb-3"
                    component={ComboBox}
                    label="Banco"
                    options={banks.map((s) => {
                      return {
                        value: s.codigo,
                        label: `${s.codigo} - ${s.banco}`,
                      };
                    })}
                  />
                </div>
                <div className="col-4 col-md-1">
                  <Field
                    type="number"
                    name="agencia"
                    noPadding
                    component={TextInput}
                    label="Agência"
                  />
                </div>
                <div className="col-5 col-md-2 px-0">
                  <Field
                    name="conta"
                    type="text"
                    component={TextInput}
                    label="Conta"
                  />
                </div>
                <div className="col-3 col-md-1">
                  <Field
                    type="text"
                    name="digito"
                    noPadding
                    component={TextInput}
                    label="Digíto"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-6" />
                <div className="col-12 col-md-6">
                  <div className="ms-auto col-6">
                    <Button type="submit" disabled={isSubmitting || !isValid}>
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
